module.exports = __webpack_public_path__ + "img/logo-2024-2.e7c54408.png";